import { createSelector } from "reselect";

const getSearchDataColegios = state => state.searchDataColegios;
const getColegiosConEscuelas = state => state.escuelas.listaColegiosEscuelas;

const getColegiosConEscuelasDisponibles = createSelector(
  [getSearchDataColegios, getColegiosConEscuelas],
  (searchDataColegios, colegiosConEscuelas) =>
    searchDataColegios.filter(item => {
      let esValido = true;
      colegiosConEscuelas.forEach(
        l => esValido && (esValido = item.childKey !== l.id)
      );
      return esValido;
    })
);

export { getColegiosConEscuelasDisponibles };



// WEBPACK FOOTER //
// ./src/ducks/inscripciones/selectors.js